import React, { useRef, memo } from 'react';

import { Modal, Button, Input, Form, Select } from 'antd';
// import { useTheme } from 'utils/Theme';
import { SurveyType } from 'models/Survey';
import { useNavigate } from 'react-router-dom';

import { Container } from './EnrollmentFormInvitationModal.style';

export interface EnrollmentFormInvitationFormProps {
  ceoEmail: string;
  ceoName: string;
  surveyId: string;
}

export interface EnrollmentFormInvitationModalProps {
  loading: boolean;
  onSubmit: (ceoEmail: EnrollmentFormInvitationFormProps) => void;
  surveys: SurveyType[];
}

const EnrollmentFormInvitationModal = (
  props: EnrollmentFormInvitationModalProps
): JSX.Element => {
  // const theme = useTheme();

  // MARK:- Hooks
  const navigate = useNavigate();

  // MARK:- Refs
  const submitButton = useRef<HTMLButtonElement>(null);

  const onFinish = (values: EnrollmentFormInvitationFormProps) => {
    props.onSubmit(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Container>
      <Modal
        visible
        centered
        title="Enrollment Form Invitation"
        onCancel={() => navigate('/dashboard/enrollment-forms')}
        footer={[
          <Button
            key="back"
            onClick={() => navigate('/dashboard/enrollment-forms')}
            disabled={props.loading}
          >
            Return
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={props.loading}
            onClick={() => submitButton.current?.click()}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          layout="vertical"
          name="enrollmentForm"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ width: '100%' }}
        >
          <Form.Item
            label="CEO Email"
            name="ceoEmail"
            rules={[
              {
                required: true,
                message: 'Please input an email',
                type: 'email',
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="CEO Name"
            name="ceoName"
            rules={[
              {
                required: true,
                message: 'Please input the CEO name',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="surveyId"
            label="Survey"
            rules={[{ required: true }]}
          >
            <Select style={{ width: '100%' }}>
              {props.surveys.map((survey) => (
                <Select.Option value={survey.id} key={survey.id}>
                  {survey.title || 'No Title'}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <button hidden type="submit" ref={submitButton}></button>
        </Form>
      </Modal>
    </Container>
  );
};

export default memo(EnrollmentFormInvitationModal);
